import { formatAsset } from './util/asset.js'

export default class AssetClient {
  constructor({ url, _axios, _error }) {
    this.url = url
    this.axios = _axios
    this.logError = _error ? _error : console.error
  }

  help() {
    console.log('newAsset({ orgId, type = "UNKNOWN", text = "", link = "", thumbnail = "" })')
    console.log('save(asset)')
  }

  newAsset({ orgId, type = 'UNKNOWN', text = '', link = '', thumbnail = '' }) {

    if (text) {
      type = 'TEXT'
      link = ''
    }

    return {
      id: undefined,
      orgId,
      type,
      link,
      text: text || '',
      cleanText: '',
      annotations: [],
      caption: '',
      tags: [],
      thumbnail
    }
  }

  async save(asset) {

    try {
      asset = await this.#create(asset)
      asset = formatAsset(asset)

      return { error: '', asset }
    } catch (error) {
      this.logError(error)

      return { error: 'file save failed', asset: null }
    }
  }

  async #create(newAsset) {

    const url = `${this.url}/api/asset`

    const res = await this.axios.post(url, { asset: newAsset })
    const response = res.data
    if (!response.success) throw 'Error creating asset'

    const asset = response.result
    return asset
  }
}